import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=4b452017&scoped=true&"
import script from "./SelectLang.vue?vue&type=script&lang=js&"
export * from "./SelectLang.vue?vue&type=script&lang=js&"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=4b452017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b452017",
  null
  
)

export default component.exports